import { Text } from '@mantine/core';
import { OperationOutcome } from '@medplum/fhirtypes';
import { ORBIT_GRAY } from '@/theme/colors';

interface ListStateMessageProps {
  patient?: unknown;
  loading: boolean;
  error: Error | OperationOutcome | undefined;
  empty: boolean;
  emptyMessage: string;
  errorMessagePrefix: string;
}

/**
 * Shared component for displaying loading, error, and empty states in list components
 */
export function ListStateMessage({
  patient,
  loading,
  error,
  empty,
  emptyMessage,
  errorMessagePrefix,
}: ListStateMessageProps) {
  if (!patient) {
    return (
      <Text size="sm" c={ORBIT_GRAY}>
        No patient selected
      </Text>
    );
  }

  if (loading) {
    return (
      <Text size="sm" c={ORBIT_GRAY}>
        Loading...
      </Text>
    );
  }

  if (error) {
    return (
      <Text size="sm" c="red">
        {errorMessagePrefix}: {error instanceof Error ? error.message : 'Unknown error'}
      </Text>
    );
  }

  if (empty) {
    return (
      <Text size="sm" c={ORBIT_GRAY}>
        {emptyMessage}
      </Text>
    );
  }

  return null;
}
